




import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';

@Component({
  components: { AdminIframe },
})
export default class ProductScreeningPopupIframe extends Vue {
  private get remoteSrc() {
    const { query, params } = this.$route;
    const queryObject = { mallProductNo: params.mallProductNo, serviceType: 'PREMIUM', ...query, };
    const queryString = new URLSearchParams(queryObject).toString();

    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/popup/product-screening?' + queryString;
  }
}
